import React, { useState, useRef, useEffect, useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import { Container, Grid, Table, Icon, Image,  } from 'semantic-ui-react'
import atar_logo from "../assets/home/atar_logo.png";
import sarukhan from "../assets/home/sarukhan.png";
import time_gif from "../assets/home/time.gif";
import { useTranslation } from "react-i18next";

const ContestBeginScreen = (props) => {
    const { t, i18n } = useTranslation();
    useEffect(() => {
        window.scrollTo(0, 0)
      }, []);
    return (
        <>

            <div className="container-fluid home clearall">
                <div className="contestflow_sec">
                    <NavLink
                        to="">
                        <img className="star_img" src={atar_logo} />
                    </NavLink>
                    <div className="lifet">

                        <Grid stackable columns={2}>
                            <Grid.Column>
                                <div className="experience ">
                                    <img className="sarukhan_img w-25" src={sarukhan} />
                                      <h5> {t("contestbegins.titel")} <span>{t("contestbegins.titel1")} </span></h5>
                                    <p>{t("contestbegins.para")}</p>
                                </div>
                            </Grid.Column>
                            <Grid.Column>

                                <Image className="time_gif" src={time_gif} />

                            </Grid.Column>
                        </Grid>

                    </div>
                </div>
            </div>
        </>
    )

}


export default (ContestBeginScreen);
